import React, {useEffect, useState, useRef} from "react";
import FilteredProduct from "./FilrteredProduct";
import {Row} from "react-bootstrap";
import ProductCard from "./EcommerceCard";
import {useDispatch, useSelector} from "react-redux";
import {getProductData as onGetProductData} from "slices/thunk";
import {ToastContainer} from "react-toastify";
import {useLocation} from "react-router-dom";

const useQuery = () => new URLSearchParams(useLocation().search);

const FilterIndex = () => {
    const dispatch = useDispatch<any>();
    const query = useQuery();
    const pageParam = query.get("page");
    const pageFromUrl = pageParam ? parseInt(pageParam) : 1;
    const [pagination, setPagination] = useState<number>(pageFromUrl);
    const size = 8;
    const isFirstRender = useRef(true);
    const productsList = useSelector((state: any) => state.Product.productList);
    const totalPages = useSelector((state: any) => state.Product.productList.page?.totalPages);
    const [searchData, setSearchData] = useState({
        name: "",
        categoryId: null,
        brandId: [],
        colorId: null,
        minPrice: null,
        maxPrice: null,
        isActive: true
    });

    useEffect(() => {
        if (searchData.name.length || searchData.colorId || searchData.categoryId || searchData.brandId || searchData.minPrice || searchData.maxPrice) {
            setPagination(1);
        }
    }, [searchData]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const pageDate = {page: pagination - 1, size: size}
        dispatch(onGetProductData({searchData, pagination: pageDate}));
    }, [searchData, dispatch, pagination]);

    return (
        <React.Fragment>
            <Row>
                <FilteredProduct setSearchData={setSearchData}/>
                <ProductCard
                    filterGrid={productsList}
                    setPagination={setPagination}
                    totalPages={totalPages}
                    pagination={pagination}
                />
                <ToastContainer/>
            </Row>
        </React.Fragment>
    );
}

export default FilterIndex;